import React from "react";
import Chart from "react-apexcharts";

const TIER_LABELS = {
  iceBreaker: "Ice Breaker",
  deeperDive: "Deeper Dive",
  wildCard: "Wild Card",
  connectionGoals: "Connection Goals",
};

/**
 * Props:
 *  data: API response data array
 */
const VaultQuestionPerformanceChart = ({ data = [] }) => {
  // Safe guard
  if (!data.length) {
    return <div className="text-center text-muted">No analytics data found</div>;
  }

  // X-axis labels (short question id)
  const categories = data.map(
    (q, index) => `${TIER_LABELS[q.tier] || q.tier} – Q${index + 1}`
  );

  // Convert "16.67%" -> 16.67
  const completionData = data.map(q =>
    parseFloat(q.completionRate.replace("%", ""))
  );

  const dropOffData = data.map(q =>
    parseFloat(q.dropOffRate.replace("%", ""))
  );

  const series = [
    {
      name: "Completed %",
      data: completionData,
    },
    {
      name: "Dropped Off %",
      data: dropOffData,
    },
  ];

  const formatSeconds = (ms) => {
    if (!ms) return "0s";
    return ms >= 60000
      ? `${Math.floor(ms / 60000)}m ${Math.round((ms % 60000) / 1000)}s`
      : `${Math.round(ms / 1000)}s`;
  };

  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: true },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        borderRadius: 4,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories,
      title: {
        text: "Vault Questions",
      },
    },
    yaxis: {
      max: 100,
      labels: {
        formatter: val => `${val}%`,
      },
      title: {
        text: "Percentage",
      },
    },
    tooltip: {
      y: {
        formatter: (val, { seriesIndex, dataPointIndex }) => {
          const q = data[dataPointIndex];
          if (!q) return `${val}%`;
          const count = seriesIndex === 0 ? q.answered : q.skipped;
          const word = seriesIndex === 0 ? "answered" : "skipped";
          return `${val}% (${count} ${word} of ${q.views} views, avg ${formatSeconds(
            q.avgTimeSpentMs
          )}, ${q.funFactViewed} fun facts viewed)`;
        },
      },
    },
    legend: {
      position: "bottom",
    },
    fill: {
      opacity: 1,
    },
  };

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      height={360}
    />
  );
};

export default VaultQuestionPerformanceChart;
